import type { TemplateSource } from '../../api/templates';

const LABELS: Record<TemplateSource, string> = {
  default: 'Flowspect default',
  custom: 'Custom',
  duplicated: 'Duplicated',
  spectora_import: 'Imported from Spectora',
};

/**
 * Small pill that shows where a template came from. Reuses the `.ts-customized`
 * chip styling so the visual language matches the rest of the templates UI
 * without requiring new tokens.
 */
export function TemplateSourceBadge({ source }: { source: TemplateSource }) {
  return <span className="ts-customized">{LABELS[source]}</span>;
}
